'use es6';

import { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import SidebarHeader from 'ContentEditorUI/components/sidebar/SidebarHeader';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SidebarWrapper = styled.div.withConfig({
  displayName: "Sidebar__SidebarWrapper",
  componentId: "sc-10o89k9-0"
})(["overflow:hidden;height:100%;"]);
const SidebarContent = styled.div.withConfig({
  displayName: "Sidebar__SidebarContent",
  componentId: "sc-10o89k9-1"
})(["display:flex;flex-direction:column;flex-grow:1;overflow-y:hidden;border-right:none;width:380px;height:100%;"]);
const SidebarBody = styled.div.withConfig({
  displayName: "Sidebar__SidebarBody",
  componentId: "sc-10o89k9-2"
})(["display:flex;flex-grow:1;position:relative;width:100%;min-height:0;"]);
export default class Sidebar extends Component {
  render() {
    return /*#__PURE__*/_jsx(SidebarWrapper, {
      className: "expanding-sidebar",
      children: /*#__PURE__*/_jsxs(SidebarContent, {
        className: "sidebar-content",
        id: "inpage-sidebar-container",
        children: [/*#__PURE__*/_jsx(SidebarHeader, {}), /*#__PURE__*/_jsx(SidebarBody, {
          children: this.props.children
        })]
      })
    });
  }
}
Sidebar.propTypes = {
  children: PropTypes.node.isRequired,
  activePanel: PropTypes.string,
  isReadOnlyMode: PropTypes.bool.isRequired
};